<template>
  <jd-focus-group-collection>
    <jd-roving-focus-group-impl v-bind="$attrs">
      <slot />
    </jd-roving-focus-group-impl>
  </jd-focus-group-collection>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import JdRovingFocusGroupImpl from './roving-focus-group-impl.vue'
import { JdCollection as JdFocusGroupCollection } from './roving-focus-group'

export default defineComponent({
  name: 'JdRovingFocusGroup',
  components: {
    JdFocusGroupCollection,
    JdRovingFocusGroupImpl,
  },
})
</script>
